// Trae informacion del state
import Cookies from "js-cookie"

export const getUserSession = (state) => {
  return Cookies.get("userSession", state.userSession)
}

export const getItemEstancias = (state) => {
  return state.itemEstancias
}